import axios from "axios";
import { triggerSessionAlert } from "../utils/SessionAlertHelper";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getSimSwapData = async (pagination, search, filter) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/simSwap/`,
      {
        pagination: pagination,
        search: search,
        filter: filter,
      },
      {
        withCredentials: true,
      }
    );

    return {
      success: response.data.success,
      message: response.data.message,
      data: response.data.data.simSwapRequests,
      totalPages: response.data.data.totalPages,
      totalCount: response.data.data.totalSimSwap,
      currentPage: response.data.data.currentPage,
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
    if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while fetching SIM swap requests.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};

export const getExportSimSwapData = async (filter, search) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/simSwap/export`,
      {
        search: search,
        filter: filter,
      },
      {
        withCredentials: true,
      }
    );

    return {
      success: response.data.success,
      message: response.data.message,
      data: response.data.data.simSwapRequests,
      totalCount: response.data.data.totalSimSwap,
      currentPage: response.data.data.currentPage,
      totalPages: response.data.data.totalPages,
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
   if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while fetching SIM swap requests.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};

export const updateSimSwapStatus = async (simSwapId, status, statusNote) => {
  try {
    const response = await axios.patch(
      `${API_BASE_URL}/simSwap/update/status`,
      {
        simSwapId: simSwapId,
        status: status,
        note: statusNote,
      },
      {
        withCredentials: true,
      }
    );

    return {
      success: response.data.success,
      message: response.data.message,
      data: response.data.data,
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
    if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while updating SIM swap status.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};
